import { RESET_FLAG } from './typeConstants';

export const resetFlag = () => ({
  type: RESET_FLAG
})
